<p-dialog [(visible)]="exibeCadastro" [style]="{width: '900px', height: '85vh'}" [header]="cadastroTitulo"
  [modal]="true" styleClass="p-fluid" (onHide)="hideDialog()">
  <ng-template pTemplate="content">
    <p-tabView>

      <p-tabPanel header="Dealer">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-3">
            <label>Código Dealer:</label>
            <input type="text" pInputText placeholder="Código do Dealer..." [(ngModel)]="cadastro.codigo"
              [disabled]="view" />
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.codigo">Código do Dealer é
              Obrigatório!</small>
          </div>
          <div class="p-field p-col-9">
            <label>Nome Dealer:</label>
            <input type="text" pInputText placeholder="Nome do Dealer..." [(ngModel)]="cadastro.nomeDealer"
              [disabled]="view" />
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.nomeDealer">Nome do Dealer é
              Obrigatório!</small>
          </div>
          <div class="p-field p-col-6">
            <label>CNPJ Dealer:</label>
            <p-inputMask mask="99.999.999/9999-99" [(ngModel)]="cadastro.cnpj" placeholder="CNPJ do Dealer..."
              unmask="true" [disabled]="view"></p-inputMask>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.cnpj">CNPJ do Dealer é
              Obrigatório!</small>
          </div>
          <div class="p-field p-col-6">
            <label>Tipo Dealers:</label>
            <p-dropdown [showClear]="true" [options]="listas.tiposDealer" [(ngModel)]="cadastro.tipoDealer"
              placeholder="Selecione..." optionLabel="descricao" optionValue="id" [disabled]="view">
            </p-dropdown>
          </div>
          <div class="p-field p-col-6">
            <label>Status Dealers:</label>
            <p-dropdown [showClear]="true" [options]="statusDealer" [(ngModel)]="cadastro.status"
              placeholder="Selecione..." optionLabel="name" optionValue="code" [disabled]="view">
            </p-dropdown>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.status">Status Dealer é
              Obrigatório!</small>
          </div>
          <div class="p-field p-col-6">
            <label>Grupo econômico:</label>
            <p-dropdown [showClear]="true" [options]="listas.gruposEconomicos" [(ngModel)]="cadastro.grupoEconomico"
              placeholder="Selecione..." optionLabel="descricao" optionValue="id" [disabled]="view">
            </p-dropdown>
          </div>
          <div class="p-field p-col-6">
            <label>Inscrição Municipal:</label>
            <input type="text" pInputText placeholder="Incrição Municipal do Dealer.."
              [(ngModel)]="cadastro.incricaoMunicipal" [disabled]="view" />
          </div>
          <div class="p-field p-col-6">
            <label>Inscrição Estadual:</label>
            <input type="text" pInputText placeholder="Incrição Municipal do Dealer.."
              [(ngModel)]="cadastro.incricaoEstadual" [disabled]="view" />
          </div>
          <div class="p-field p-col-6">
            <label>Regional:</label>
            <p-dropdown [options]="listas.itensRegional" [(ngModel)]="cadastro.idRegional" placeholder="Selecione..."
              optionLabel="descricao" optionValue="id" [appendTo]="'body'" [autoZIndex]="true" [baseZIndex]="9999"
              [disabled]="view">
            </p-dropdown>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Endereço">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-7">
            <label>CEP:</label>
            <p-inputMask mask="99999-999" [(ngModel)]="cadastro.cep" placeholder="Informe o CEP..."
              (onComplete)="buscarCEP()" unmask="true" [disabled]="view"></p-inputMask>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.cep">CEP é obrigatório!</small>
            <small class="p-invalid text-danger" *ngIf="erroCEP">CEP não encontrado</small>
          </div>
          <div class="p-field p-col-6">
            <label>País:</label>
            <p-dropdown [showClear]="true" [options]="listas.itensPais" [(ngModel)]="cadastro.pais"
              placeholder="Selecione..." optionLabel="descricao" optionValue="id" [filter]="true" [disabled]="view">
            </p-dropdown>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.pais">País é obrigatório!</small>
          </div>
          <div class="p-field p-col-6">
            <label>Região:</label>
            <p-dropdown [showClear]="true" [options]="listas.itensRegiao" [(ngModel)]="cadastro.regiao"
              placeholder="Selecione..." optionLabel="descricao" optionValue="id" (onChange)="carregarDDLUf(0)"
              [disabled]="view">
            </p-dropdown>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.regiao">Região é obrigatório!</small>
          </div>
          <div class="p-field p-col-6">
            <label>UF:</label>
            <p-dropdown [showClear]="true" [options]="listas.itensUf" [(ngModel)]="cadastro.uf"
              placeholder="Selecione..." optionLabel="descricao" optionValue="id" (onChange)="carregarDDLCidade(0)"
              [disabled]="view">
            </p-dropdown>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.uf">UF é obrigatório!</small>
          </div>
          <div class="p-field p-col-6">
            <label>Cidade:</label>
            <p-dropdown [showClear]="true" [options]="listas.itensCidade" [(ngModel)]="cadastro.cidade"
              placeholder="Selecione..." optionLabel="descricao" optionValue="id" [filter]="true" [disabled]="view">
            </p-dropdown>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.cidade">Cidade é obrigatório!</small>
          </div>
          <div class="p-field p-col-8">
            <label>Logradouro:</label>
            <input type="text" pInputText placeholder="Logradouro do endereço..." [(ngModel)]="cadastro.logradouro"
              [disabled]="view" />
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.logradouro">Logradouro é
              obrigatório!</small>
          </div>
          <div class="p-field p-col-4">
            <label>Número:</label>
            <input type="number" pInputText placeholder="Número do endereço..." [(ngModel)]="cadastro.numero"
              [disabled]="view" />
          </div>
          <div class="p-field p-col-6">
            <label>Bairro:</label>
            <input type="text" pInputText placeholder="Bairro..." [(ngModel)]="cadastro.bairro" [disabled]="view" />
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.bairro">Bairro é obrigatório!</small>
          </div>
          <div class="p-field p-col-6">
            <label>Complemento:</label>
            <input type="text" pInputText placeholder="Complemento do endereço..." [(ngModel)]="cadastro.complemento"
              [disabled]="view" />
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Contato">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12">
            <label>Nome Contato:</label>
            <input type="text" pInputText placeholder="Nome do Contato..." [(ngModel)]="cadastro.nomeContato"
              [disabled]="view" />
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.nomeContato">Nome do Contato é
              Obrigatório!</small>
          </div>
          <div class="p-field p-col-2">
            <label>DDD:</label>
            <p-inputMask mask="(99)" [(ngModel)]="cadastro.ddd" placeholder="DDD" unmask="true"
              [disabled]="view"></p-inputMask>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.ddd">DDD é Obrigatório!</small>
          </div>
          <div class="p-field p-col-4">
            <label>Telefone Contato:</label>
            <p-inputMask mask="9999-9999" [(ngModel)]="cadastro.telefone" placeholder="Telefone do Contato..."
              unmask="true" [disabled]="view"></p-inputMask>
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.telefone">Telefone do Contato é
              Obrigatório!</small>
          </div>
          <div class="p-field p-col-6">
            <label>E-mail Contato:</label>
            <input type="text" pInputText placeholder="E-mail do Contato..." [(ngModel)]="cadastro.email" />
            <small class="p-invalid text-danger" *ngIf="submitted && !cadastro.email">E-mail do Contato é
              Obrigatório!</small>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Gestor">
        <div class="p-fluid p-formgrid p-grid">
          <p-tabView>
            <p-tabPanel header="Veículos">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-10">
                  <label>Nome Gestor:</label>
                  <input type="text" pInputText placeholder="Nome do Gestor Veiculo..." [(ngModel)]="cadastroGestor.nomeGestorVeiculo"
                    [disabled]="view" />
                  <small class="p-invalid text-danger" *ngIf="submitted && cadastroGestor.cpfGestorVeiculo && !cadastroGestor.nomeGestorVeiculo">Nome do Gestor é
                    Obrigatório!</small>
                </div>
                <div class="p-field p-col-10">
                  <label>CPF:</label>
                  <p-inputMask mask="999.999.999-99" [(ngModel)]="cadastroGestor.cpfGestorVeiculo" placeholder="CPF do Gestor Veiculo..."
                    unmask="true" [disabled]="view"></p-inputMask>
                  <small class="p-invalid text-danger" *ngIf="submitted && cadastroGestor.nomeGestorVeiculo && !cadastroGestor.cpfGestorVeiculo">CPF do Gestor é
                    Obrigatório!</small>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="Peças">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-10">
                  <label>Nome Gestor:</label>
                  <input type="text" pInputText placeholder="Nome do Gestor Peças..." [(ngModel)]="cadastroGestor.nomeGestorPeca"
                    [disabled]="view" />
                  <small class="p-invalid text-danger" *ngIf="submitted && cadastroGestor.cpfGestorPeca && !cadastroGestor.nomeGestorPeca">Nome do Gestor é
                    Obrigatório!</small>
                </div>
                <div class="p-field p-col-10">
                  <label>CPF:</label>
                  <p-inputMask mask="999.999.999-99" [(ngModel)]="cadastroGestor.cpfGestorPeca" placeholder="CPF do Gestor Peças..."
                    unmask="true" [disabled]="view"></p-inputMask>
                  <small class="p-invalid text-danger" *ngIf="submitted && cadastroGestor.nomeGestorPeca && !cadastroGestor.cpfGestorPeca">CPF do Gestor é
                    Obrigatório!</small>
                </div>
              </div>
            </p-tabPanel>
            <p-tabPanel header="Pós-Venda">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-10">
                  <label>Nome Gestor:</label>
                  <input type="text" pInputText placeholder="Nome do Gestor Pós-Venda..." [(ngModel)]="cadastroGestor.nomeGestorPosVenda"
                    [disabled]="view" />
                  <small class="p-invalid text-danger" *ngIf="submitted && cadastroGestor.cpfGestorPosVenda && !cadastroGestor.nomeGestorPosVenda">Nome do Gestor é
                    Obrigatório!</small>
                </div>
                <div class="p-field p-col-10">
                  <label>CPF:</label>
                  <p-inputMask mask="999.999.999-99" [(ngModel)]="cadastroGestor.cpfGestorPosVenda" placeholder="CPF do Gestor Pós-Venda..."
                    unmask="true" [disabled]="view"></p-inputMask>
                  <small class="p-invalid text-danger" *ngIf="submitted && cadastroGestor.nomeGestorPosVenda && !cadastroGestor.cpfGestorPosVenda">CPF do Gestor é
                    Obrigatório!</small>
                </div>
              </div>
            </p-tabPanel>
          </p-tabView>
        </div>
      </p-tabPanel>

    </p-tabView>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton label="Alterar" *ngIf="view" icon="pi pi-pencil" class="p-button-text" (click)="edit()"></button>
    <button pButton label="Salvar" *ngIf="!view" icon="pi pi-check" class="p-button-text"
      (click)="saveDados()"></button>
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
  </ng-template>
</p-dialog>